module.exports = __webpack_public_path__ + "static/article-image-second-df37c3230fc8a70b52f276dd16bccdfd.jpg";